/* eslint-disable no-param-reassign */
import rootAPIs from '@/api/rootAPIs';


const state = {
  currentForm: '',
  currentFormIndex: 0,
  forms: [],
  verificationAttempts: 0,
};

const mutations = {
  /**
   * Set current form.
   * @param {string} form - Form name.
   */
  setCurrentForm(formState, form) {
    formState.currentForm = form;
  },
  /**
   * Set forms.
   * @param {Object[]} forms - Array of form objects.
   */
  setForms(formState, forms) {
    formState.forms = forms;
  },
  /**
   * Sets the index of the current form.
   * @param {number} index
   */
  setCurrentFormIndex(formState, index) {
    formState.currentFormIndex = index;
  },
  /**
   * Disables specific fields of a form.
   * @param {Object} obj - An object.
   * @param {number} obj.formIndex - The form index.
   * @param {string[]} obj.fieldNames - List of field names to be disabled.
   */
  disableFormFields(formState, { formIndex, fieldNames }) {
    const form = formState.forms[formIndex];
    form.fields.forEach((field) => {
      field.disabled = fieldNames.includes(field.key);
    });
  },
  /**
   * Add one to the current form index.
   */
  incrementFormIndex(formState) {
    formState.currentFormIndex += 1;
  },
  /**
   * Subtract one from the current form index.
   */
  decrementFormIndex(formState) {
    formState.currentFormIndex -= 1;
  },
  /**
   * Add one to the verification attemps.
   */
  incrementVerificationAttempts(formState) {
    formState.verificationAttempts += 1;
  },
};

const getters = {
  /**
   * Gets the form that is currently showing in the modal
   * @param formState The current state object
   */
  getCurrentForm: formState => formState.currentForm,

  /**
   * Gets all forms
   * @param formState The current state object
   */
  getCurrentForms: formState => formState.forms,

  /**
   * Gets the index of the current form
   * @param formState The current state object
   */
  getCurrentFormIndex: formState => formState.currentFormIndex,

  /**
   * Gets the next form object
   * @param formState The current state object
   */
  getCurrentFormObject: formState => formState.forms[formState.currentFormIndex],
};

const actions = {
  /**
   * Set the the forms array from the given application id.
   *
   * @param applicationId The ID that will be used to request the config from the server
   */
  setCurrentForms({ commit }, { applicationId }) {
    return rootAPIs.getForms(applicationId)
      .then(result => commit('setForms', result.data));
  },
};

export default {
  namespaced: true,
  state,
  mutations,
  getters,
  actions,
};
